import { render } from "./PriceListProductBuilderModal.vue?vue&type=template&id=2b9bbc57&scoped=true"
import script from "./PriceListProductBuilderModal.vue?vue&type=script&lang=js"
export * from "./PriceListProductBuilderModal.vue?vue&type=script&lang=js"

import "./PriceListProductBuilderModal.vue?vue&type=style&index=0&id=2b9bbc57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9bbc57"]])

export default __exports__